import { createFileRoute, notFound } from "@tanstack/react-router";
import type { ModerationPolicyCategory } from "shared/Classification";
import { MODERATION_POLICY_CATEGORIES } from "shared/ModerationCategories";
import CategoryPolicyPage from "src/routes/_authed/portal/-components/moderation-policies/CategoryPolicyPage";

export const Route = createFileRoute(
  "/_authed/portal/org_{$orgKey}/moderation-policies/$policyId/$category",
)({
  beforeLoad: ({ params }) => {
    if (!(MODERATION_POLICY_CATEGORIES as readonly string[]).includes(params.category))
      throw notFound();
  },
  component: CategoryRoute,
});

function CategoryRoute() {
  const { category } = Route.useParams();
  return <CategoryPolicyPage key={category} category={category as ModerationPolicyCategory} />;
}
